import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Header, NavHeader, Page } from '../../components';

type ActionCreateTaskTypesProps = {
  children: ReactNode[];
};

export const ActionCreateTaskTypes: React.FC<ActionCreateTaskTypesProps> = ({ children }) => {
  const { t } = useTranslation('action');

  return (
    <Page
      isStickyHeader
      header={
        <>
          <NavHeader />
          <Header title={t('action.create.tasks.task')} />
        </>
      }
    >
      <div className="grid-list-24">{children}</div>
    </Page>
  );
};
